import sentryClientInit from "@project/config/sentry.client.config";
import { getAppConfig } from "@project/core/utils/nextPublicConfigRuntime";
import { appConfigParams } from "utils/nextPublicConfigRuntime";

sentryClientInit(getAppConfig(appConfigParams).NEXT_PUBLIC_SENTRY_DSN);
